<style lang="scss">
@import './index.scss';
</style>

<template>
  <div>
    <div class="usergroup">
        <h1>{{ $t('nav.user.group') }}</h1>
        <div class="usergroup-operation">
          <!-- 创建用户分群 -->
          <i-button
            type="primary"
            shape="circle"
            icon="md-add"
            class="l"
            @click="addUserGroup('add_newusergroup')">{{ $t('userGroup.add') }}</i-button>
          <div class="usergroup-search">
            <!-- 删除 -->
            <Button
              ghost-tmp
              shape="circle"
              class="usergroup-search-div"
              :disabled="selection.length === 0"
              @click="delModal = true">
                <i class="iconfont icon-del usergroup-icon"></i>
                {{ $t('userGroup.delete') }}
            </Button>
            <!-- 查阅详情 -->
            <Button
              ghost-tmp
              shape="circle"
              class="usergroup-search-div"
              :disabled="overviewSelection"
              @click="goOverview">
                <i class="iconfont icon-analytics usergroup-icon"></i>
                {{ $t('userGroup.detail') }}
            </Button>
            <!-- <Button>精准推送</Button> -->
            <!-- 搜索框 -->
            <i-input
              icon="ios-search"
              v-model="filterKey"
              :placeholder="$t('filter.search')"
              class="usergroup-search-div"
              style="width:160px"
              @on-change="filterTableData"></i-input>
          </div>
        </div>
        <tableMove
          :change-data="tableData"
          :table-columns="tableColumns"
          :noData="noData"
          @on-change-select="onTableChangeSelect"
          @on-table-move-sort="sortTable"
        ></tableMove>
        <!-- 删除分群弹窗信息 -->
        <Modal
            v-model="delModal"
            loading
            class-name="user-group-modal"
            @on-ok="deleteMulti">
            <div slot="header"></div>
            <p class="manage-event-paragraph">{{$t('userGroup.delInfo.a')}}</p>
            <p class="manage-event-paragraph">{{$t('userGroup.delInfo.b')}}</p>
        </Modal>
    </div>
  </div>
</template>
<script>
import expressionMove from './user-group-expression';
import safeHtml from '../../filters/html-formate';
import bus from '../../libs/bus';
import util from '../../libs/util';
import numberSeparator from '../../filters/number-separator';
import tableMove from '../../components/table-move/table-move';
import sortData from '../../filters/sort-table-data';

export default {
  name: 'userGroup',
  data() {
    return {
      filterKey: '',
      selection: [],
      tableData: [],
      noData: this.$t('common.loading'),
      saveTableData: '',
      // 分页相关
      curPage: 1,
      pages: 0,
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      // 弹窗
      delModal: false,
      initList: [], // 计算中的用户分群
      mcInfoShow: true,
      tableColumns: [],
    };
  },
  components: {
    expressionMove,
    tableMove,
  },
  computed: {
    detailColumnWidth() {
      return document.getElementsByClassName('usergroup-expression-column')[0].clientWidth;
    },
    overviewSelection() {
      return this.selection.length === 0 || this.selection.filter(x => x.status === 'FAILED').length > 0;
    },
  },
  methods: {
    toMc() {
      this.$router.push({
        name: 'mcDrainage',
      });
    },
    closeMcInfo() {
      this.mcInfoShow = false;
    },
    getColumns() {
      const self = this;
      self.tableColumns = [{
        type: 'selection',
        width: 60,
        align: 'center',
      }, {
        key: 'cohortName',
        width: 150,
        title: self.$t('userGroup.name'),
        render(h, params) {
          return h('div', [
            h('p', {
              class: {
                textEllipsis: true,
              },
              domProps: {
                title: safeHtml(params.row.cohortName),
              },
            }, safeHtml(params.row.cohortName)),
          ]);
        },
      }, {
        key: 'expression',
        title: self.$t('userGroup.filter'),
        ellipsis: true,
        className: 'usergroup-expression-column',
        render(h, params) {
          return h('div', {
            style: {
              'padding-top': '5px',
            },
          }, [
            h(expressionMove, {
              props: {
                expressionInfo: params.row.detail,
                detailWidth: self.detailColumnWidth,
              },
            }),
          ]);
        },
      }, {
        key: 'status',
        width: 100,
        title: self.$t('userGroup.state'),
        sortable: 'custom',
        render(h, params) {
          let str = self.$t('userGroup.stable');
          if (params.row.status === 'INIT') str = self.$t('userGroup.init');
          if (params.row.status === 'FAILED') str = self.$t('userGroup.failed');
          return h('p', str);
        },
      }, {
        key: 'updateTime',
        title: self.$t('userGroup.time'),
        width: 140,
        sortable: 'custom',
        render(h, params) {
          const time = params.row.status === 'INIT' || params.row.updateTime === null ? '--' :
           `${new Date(params.row.updateTime).toLocaleDateString()} ${new Date(params.row.updateTime).toTimeString().slice(0, 8)}`;
          return h('div', {
            domProps: {
              title: time,
            },
          }, time);
        },
      }, {
        key: 'userCount',
        width: 100,
        title: self.$t('userGroup.scale'),
        align: 'right',
        sortable: 'custom',
        render(h, params) {
          const count = params.row.status === 'INIT' || params.row.userCount === null ?
            '--' : numberSeparator(params.row.userCount);
          return h('div', count);
        },
      }, {
        key: 'operation',
        width: 80,
        align: 'center',
        title: self.$t('userGroup.operation'),
        render(h, params) {
          const initClass = params.row.status === 'INIT' ? 'disabled-operation' : 'hover-style';
          const isFailed = params.row.status === 'FAILED';
          return h('div', [
            h('i', {
              class: `iconfont icon-edit tm-icon-font tm-icon-font-operation ${initClass}`,
              on: {
                click: () => {
                  self.addUserGroup(params.row);
                },
              },
            }),
            h('Icon', {
              props: {
                type: 'android-refresh',
                size: '18',
              },
              style: {
                cursor: 'pointer',
                color: '#3399ff',
                'margin-left': '5px',
                display: isFailed ? 'inline-block' : 'none',
              },
              nativeOn: {
                click: () => {
                  self.refreshUserGroup(params.row);
                },
              },
            }),
          ]);
        },
      }];
    },
    init() {
      this.tableData = [];
      this.saveTableData = '';
      this.noData = this.$t('common.loading');
      this.mcInfoShow = !bus.productInfo.authorized;
      this.getData(1);
      this.getColumns();
    },
    /**
     * 获取表格数据
     * @param {flag} [Number] 标识递归次数
     */
    getData(flag) {
      // eslint-disable-next-line
      if (this && this._isDestroyed) return;
      const params = {
        cohortType: 'USER',
        productId: bus.productid,
        platformIds: bus.platform.toString(),
      };
      const url = '/cohort/api/v1/cohort/getAll';
      util.ajax.post(url, params).then((res) => {
        const self = this;
        const data = res;
        // 如果当前分群还在计算中，禁止选择
        if (flag === 1) {
          // eslint-disable-next-line
          data.map(x => x._disabled = x.status === 'INIT');
          // 按照更新时间降序排列
          data.sort((a, b) => b.updateTime - a.updateTime);
          self.tableData = data;
        }

        self.saveTableData = JSON.stringify(data);
        if (self.tableData.length === 0) self.noData = self.$t('common.nodata');

        // 计算中的项
        const initList = data.filter(item => item.status === 'INIT');
        if (self.initList.length === 0 && initList.length > 0) {
          self.initList = initList;
        } else if (self.initList.length && initList.length) {
          const cohortIdList = self.initList.map(x => x.cohortId);
          initList.forEach((v) => {
            if (cohortIdList.indexOf(v.cohortId) === -1) self.initList.push(v);
          });
        }
        if (initList.length === 0 && flag === 1) return;
        // 没有计算中项时不递归，此时可能是失败||成功
        if (initList.length === 0 && self.initList.length > 0) {
          self.tableData.forEach((v, index) => {
            // 赋值计算完成的项
            self.initList.forEach((val) => {
              if (val.cohortId === v.cohortId) {
                self.tableData[index].status =
                  data.filter(ajaxRes => ajaxRes.cohortId === v.cohortId)[0].status;
                self.tableData[index]._disabled = false;  // eslint-disable-line
                self.tableData[index].userCount =
                data.filter(ajaxRes => ajaxRes.cohortId === v.cohortId)[0].userCount;
                self.tableData[index].storeKey =
                  data.filter(ajaxRes => ajaxRes.cohortId === v.cohortId)[0].storeKey;
              }
            });
            /* 以下为了解决 选中项的对号随递归消失的bug */
            // tableData._disabled 改变会使选中的对号消失，这里做处理
            self.selection.forEach((seleted) => {
              if (seleted.cohortId === v.cohortId) {
                // eslint-disable-next-line
                self.tableData[index]._checked = true;
              }
            });
          });
          self.saveTableData = JSON.stringify(self.tableData);
          return;
        }
        setTimeout(() => {
          self.getData(flag + 1);
        }, 10000);
      }).catch((error) => {
        if (error.response) {
          this.$Message.error({
            content: `${this.$t('nav.user.group')}${this.$t('common.errorTip')}`,
            duration: 3,
          });
        }
      });
    },
    // 跳转数据探索页面，展示近30天活跃数据
    goOverview() {
      // 存储筛选的用户分群条件
      if (bus.productInfo.authorized && bus.productInfo.authorizedpage.indexOf('timeRangeAnalysis') === -1) {
        this.$Message.destroy();
        this.$Message.warning({
          content: '未授权此功能',
        });
        return;
      }
      bus.conditions.newUserGroup = this.selection.map(x => x.storeKey);
      bus.selectedDate = [bus.getDay(-30), bus.getDay(0)];
      bus.queryMetric = {
        left: {
          first: 'launchuser',
          second: 'daylaunchuser',
        },
        right: {
          first: '',
          second: '',
        },
        x: 'day',
      };
      try {
        localStorage.setItem('_analytics_query_metric', JSON.stringify(bus.queryMetric));
      } catch (e) {
        // e
      }
      // 派发筛选条件变更事件
      bus.$emit('on-filter-change', 'usergroup');
      this.$router.push({
        name: 'exploration',
        params: {
          productid: bus.productInfo.productid || this.$route.params.productid,
        },
      });
    },
    // 删除选中的用户分群
    deleteMulti() {
      const ids = this.selection.map(x => x.cohortId).toString();
      const storeKey = this.selection.map(x => x.storeKey);
      util.ajax.delete(`/cohort/api/v1/cohort/delete/${bus.productid}?cohortIds=${ids}`)
        .then(() => {
          this.selection = [];
          this.delModal = false;
          this.$Message.success({
            content: `${this.$t('userGroup.delete')}${this.$t('common.suc')}`,
            duration: 3,
          });
          this.init();
          bus.$emit('on-delete-usergroup', storeKey);
        }).catch((error) => {
          if (error.response) {
            this.$Message.error({
              content: `${this.$t('userGroup.delete')}${this.$t('common.fail')}`,
              duration: 3,
            });
            this.delModal = false;
          }
        });
    },
    /**
     * table 选中行操作
     * @param  {[Array]} select [已选中的列表项]
     */
    onTableChangeSelect(select) {
      this.selection = select;
    },
    /**
     * 重新计算指定的用户分群  暂不支持
     * @param  {[Object]} info [点击的行数据]
     * @return [更改当前行的 status为 'INIT'状态 ==> '计算中...']
     */
    refreshUserGroup(info) {
      util.ajax.post(`/cohort/api/v1/cohort/trigger/${bus.productid}/${info.cohortId}`)
        .then((res) => {
          this.tableData.forEach((v) => {
            const x = v;
            if (x.cohortId === res.id) {
              x.status = 'INIT';
            }
            return x;
          });
          this.getData();
        });
    },
    /**
     *  跳转创建或编辑用户分群
     * @param {[String]} flag [创建或编辑的 key]
     */
    addUserGroup(flag) {
      if (flag.status === 'INIT') return;

      const cohortId = flag === 'add_newusergroup' ? '' : flag.cohortId;
      bus.setUserGroupId = cohortId;
      try {
        sessionStorage.setItem('_app_setUserGroupId', cohortId);
      } catch (e) {
        // eslint-disable-next-line
        bus.sessionStorage._app_setUserGroupId = cohortId;
      }


      this.$router.push({
        name: 'addNewGroup',
        params: {
          productid: bus.productInfo.productid || this.$route.params.productid,
          cohortId: flag.cohortName || flag,
        },
      });
    },
    // 筛选条件筛选
    filterDetail(keyArray, key) {
      const type = ['newuser', 'launchuser'].filter(x => keyArray.indexOf(x) > -1)
        .map(x => this.$t(`userGroup.userExpression.${x}`))
        .filter(x => x.indexOf(key) > -1).length > 0;
      const attr = ['user_region', 'isp_info', 'mobile_info', 'os_info', 'partner_info']
        .filter(x => keyArray.indexOf(x) > -1)
        .map(x => this.$t(`userGroup.userExpression.userAttributeItem.${x}`))
        .filter(x => x.indexOf(key) > -1).length > 0;
      const beh = ['launch_info', 'lostDays', 'customevent', 'page_view']
        .filter(x => keyArray.indexOf(x) > -1)
        .map(x => this.$t(`userBehavior.${x}.title`))
        .filter(x => x.indexOf(key) > -1).length > 0;
      return type || attr || beh;
    },
    // 筛选 tableData
    filterTableData() {
      const key = this.filterKey.toLowerCase();
      const data = JSON.parse(this.saveTableData);
      this.tableData = data.filter((x) => {
        let back;
        if (x.detail) {
          const keyName = Object.keys(JSON.parse(x.detail));
          back = x.detail.toLowerCase().indexOf(key) > -1 || this.filterDetail(keyName, key);
        }
        return x.cohortName.toLowerCase().indexOf(key) > -1 || back;
      });
      this.noData = this.tableData.length === 0 ?
       this.$t('common.nodata') : this.$t('common.loading');
    },
    sortTable(obj, tableData) {
      const data = tableData;
      const list = sortData(obj, data);
      this.tableData = list;
    },
  },
  mounted() {
    const self = this;
    bus.$on('on-app-change', () => {
      self.init();
    });
    bus.$on('on-platform-change', () => {
      self.init();
    });
    bus.$on('on-change-lang', self.getColumns);
    if (!bus.productInfo.productid) {
      return;
    }
    self.init();
  },
  beforeDestroy() {
    bus.$off('on-app-change');
    bus.$off('on-platform-change');
    bus.$off('on-change-lang', this.getColumns);
  },
};

</script>
